import './styles/main.css';
import { World } from './scene/World';
import { Hud } from './ui/Hud';
import { sound } from './audio/SoundEngine';

function hasWebGLSupport(): boolean {
  try {
    const canvas = document.createElement('canvas');
    return !!(
      window.WebGLRenderingContext &&
      (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
    );
  } catch {
    return false;
  }
}

function init() {
  const container = document.getElementById('canvas-container');
  if (!container) {
    throw new Error('Canvas container element not found');
  }

  // Check WebGL capability
  if (!hasWebGLSupport()) {
    container.innerHTML = `
      <div style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
        color: #00fff2;
        font-family: 'Share Tech Mono', monospace;
        text-align: center;
        padding: 24px;
        background: #060810;
      ">
        <h1 style="font-family: 'Orbitron', sans-serif; font-size: 28px; margin-bottom: 16px;">WEBGL 3D ACCELERATION UNAVAILABLE</h1>
        <p style="color: #94a3b8; max-width: 600px; margin-bottom: 24px; line-height: 1.6;">
          Your current environment does not support 3D WebGL rendering context. You can access all Toille games and experiences directly below:
        </p>
        <div style="display: flex; gap: 16px; flex-wrap: wrap; justify-content: center;">
          <a href="https://racer.toille.uk" style="
            background: #ff007f;
            color: #fff;
            padding: 12px 24px;
            text-decoration: none;
            font-weight: bold;
            border-radius: 4px;
          ">🏎️ TOILLE-RACER (racer.toille.uk)</a>
          <a href="https://ide.toille.uk" style="
            background: #00fff2;
            color: #000;
            padding: 12px 24px;
            text-decoration: none;
            font-weight: bold;
            border-radius: 4px;
          ">⚡ TOILLE-IDE (ide.toille.uk)</a>
        </div>
      </div>
    `;
    return;
  }

  // Initialize 3D World & Cyberpunk HUD
  const world = new World(container);
  new Hud(world);

  // Animation Loop
  function animate() {
    requestAnimationFrame(animate);
    world.update();
  }
  animate();

  // Hide initial loading screen if present
  const loader = document.getElementById('loading-screen');
  if (loader) {
    setTimeout(() => {
      loader.classList.add('fade-out');
      setTimeout(() => loader.remove(), 600);
    }, 400);
  }

  // User gesture to kick off audio environment
  const onFirstInteraction = () => {
    sound.startAtmosphere();
    window.removeEventListener('pointerdown', onFirstInteraction);
    window.removeEventListener('keydown', onFirstInteraction);
  };
  window.addEventListener('pointerdown', onFirstInteraction);
  window.addEventListener('keydown', onFirstInteraction);
}

window.addEventListener('DOMContentLoaded', init);
